import jsonFetch, {retriers} from 'json-fetch';

class ReadJsonDataService {
  getExamCentreList() {
    return jsonFetch(`${process.env.REACT_APP_EXAM_CENTRE_LIST_GET_ENDPOINT}`, {
      method: 'GET',
      shouldRetry: retriers.isNetworkError, // after every request, retry if a network error is thrown
      retry: {
        // Retry 5 times, in addition to the original request
        retries: 5,
      }
    }).then(response => response);
  }

  getInstitutionList(fileName) {
    return jsonFetch(`${process.env.REACT_APP_INSTITUTION_LIST_GET_ENDPOINT}${fileName}`, {
      method: 'GET',
      shouldRetry: retriers.isNetworkError, // after every request, retry if a network error is thrown
      retry: {
        // Retry 5 times, in addition to the original request
        retries: 5,
      }
    }).then(response => response);
  }
}
const instance = new ReadJsonDataService();
Object.freeze(instance);
  
export default instance;